/**
 * Created by Ivan on 23.09.2026
 */

const SeasonPassNudgeDays = [10, 20];

const countSeasonPassNudges = function (mission) {
    const day = mission.logic.getSeasonDay();
    return SeasonPassNudgeDays.filter((nudgeDay) => day >= nudgeDay).length;
};

Placements.ENTRIES["seasonPassPurchaseNudge"] = {
    throttled: true,

    type: Placements.FREE_FOCUS_MAIN,

    filter: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_SEASON_PASS);
        return mission && !mission.needShowStartWindow && !mission.logic.isSuperUnlocked()
            && countSeasonPassNudges(mission) > mission.logic.nudges;
    },

    action: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_SEASON_PASS);
        mission.logic.markNudges(countSeasonPassNudges(mission));

        cleverapps.focusManager.display({
            focus: "SeasonPassPurchaseNudge",
            action: function (f) {
                new SeasonPassPurchaseWindow(mission);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};

Placements.ENTRIES["seasonPassCompletedTasks"] = {
    throttled: true,

    type: Placements.FREE_FOCUS,
    priority: -1,

    filter: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_SEASON_PASS);
        return cleverapps.environment.isMainScene() && mission && !mission.needShowStartWindow && mission.logic.hasCompletedTasksToShow();
    },

    action: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_SEASON_PASS);

        cleverapps.focusManager.display({
            focus: "SeasonPassCompletedTasks",
            action: function (f) {
                mission.logic.showMainWindow(f);
            }
        });
    }
};
